export default __webpack_public_path__ + "static/eiffel-tower-keyring-4770db4290a6165a4f9c6c8571360668.jpg";